import { Schema, SchemaSettings } from '@orbit/data'
import { findRemoteIdFromNewRecord, KC } from '@/http/utils'
import moment from 'moment-timezone'

enum ModelTypes {
  SiteDetailed = 'detailed-site',
}

enum ModelTypeNames {
  SiteDetailed = 'detailedSite',
}

export interface SiteDetailed {
  programName: string
  programInteractions: number
  programAvgAdherencePerc: number
  programPatientsTotal: number
  programPatientsActive: number
  programPatientsCompleted: number
}

export interface SiteDetailedAttributes {
  id: string
  siteName: string
  org: string
  regionalHealthAuthority: string
  patientMonitoringEnabled: boolean
  myPatientsEnabled: boolean
  kcPatientResourceType: string
  pccOrg: string
  pccFacId: string
  residexClientId: string
  residexCampusId: string
  pids: string[]
  devicesToAssign?: object[]
  availableVibes: number
  syncPatientsFromEmr: boolean
  syncAllPatientsFromEmr: boolean
  syncMinimalPatientAttributes: boolean
  syncCaregiversFromEmr: boolean
  sharedDevicesMatchRoomNumber: boolean
  sharedDevicesMatchResidentNumber: boolean
  units?: object[]
  emrPatients?: object[]
  glucometerProgramStartDate: string
  glucometerProgramEndDate: string
  vitalsProgramStartDate: string
  vitalsProgramEndDate: string

  glucometerStripRevenue: number
  gatewaySalePrice: number
  gatewayInstallationFee: number

  saveDefaultForRegionalHealthAuthority: boolean
}

export interface SiteDetailedScheme {
  id: string
  attributes: SiteDetailedAttributes
}

const schemaDefinition: SchemaSettings = {
  models: {
    [ModelTypeNames.SiteDetailed]: {
      keys: {
        remoteId: {},
      },
      attributes: {
        id: { type: 'string' },
        siteName: { type: 'string' },
        org: { type: 'string' },
        regionalHealthAuthority: { type: 'string' },
        patientMonitoringEnabled: { type: 'boolean' },
        myPatientsEnabled: { type: 'boolean' },
        pccOrg: { type: 'string' },
        pccFacId: { type: 'string' },
        residexClientId: { type: 'string' },
        residexCampusId: { type: 'string' },
        pids: { type: 'string' }, // shouldn't it be array?
        devicesToAssign: { type: 'array' },
        availableVibes: { type: 'number' },
        syncPatientsFromEmr: { type: 'boolean' },
        syncAllPatientsFromEmr: { type: 'boolean' },
        syncMinimalPatientAttributes: { type: 'boolean' },
        syncCaregiversFromEmr: { type: 'boolean' },
        sharedDevicesMatchRoomNumber: { type: 'boolean' },
        sharedDevicesMatchResidentNumber: { type: 'boolean' },
        kcPatientResourceType: { type: 'string' },
        units: { type: 'array' },
        emrPatients: { type: 'array' },
        glucometerProgramStartDate: { type: 'string' },
        glucometerProgramEndDate: { type: 'string' },
        vitalsProgramStartDate: { type: 'string' },
        vitalsProgramEndDate: { type: 'string' },

        monthlyRevenue: { type: 'number' },
        monthlyCost: { type: 'number' },
        glucometerStripRevenue: { type: 'number' },

        gatewaySalePrice: { type: 'number' },
        gatewayInstallationFee: { type: 'number' },

        // oneTimeGlucometerGatewayCost: { type: 'number' },
        // oneTimeVitalsGatewayCost: { type: 'number' },
        // oneTimeVitalsGatewayRevenue: { type: 'number' },
        saveDefaultForRegionalHealthAuthority: { type: 'boolean' },
      },
    },
  },
}

export interface GetSiteDetailedByIdDto {
  siteId: string
}

export async function getDetailedSiteById(params: GetSiteDetailedByIdDto) {
  const schema = new Schema(schemaDefinition)
  const remote = await KC.getJsonApiRemoteResource(schema)

  const queryExpression = q => {
    console.log('Before calling find record for detailed site ', params.siteId)
    const expression = q.findRecords(ModelTypes.SiteDetailed)
    return expression.filter({ attribute: 'id', value: params.siteId })
  }

  return remote.query(queryExpression).catch(e => {
    console.log('fetch failed for detailed sites')
    console.log(e)
  })
}
//
// export async function patchDetailedSiteQuery(payload) {
//   let p = payload
//   let s = schemaDefinition
//   const schema = new Schema(schemaDefinition)
//   const remote = await KC.getJsonApiRemoteResource(schema)
//   return remote.push(q => {
//     console.log('Before calling update record for detailed-site')
//     return q.updateRecord({
//       id: payload.id,
//       type: ModelTypeNames.Site,
//       attributes: payload.attributes,
//     })
//   })
// }
//
// export async function createDetailedSiteQuery(payload) {
//   const schema = new Schema(schemaDefinition)
//   const remote = await KC.getJsonApiRemoteResourceForNewRecord(schema)
//   const result = await remote.push(q => {
//     // let id = payload.attributes.siteName + '-00'
//     // payload.attributes.id = id
//     console.log('Before calling push record for site')
//     return q.addRecord({
//       id: '',
//       type: ModelTypeNames.SiteDetailed,
//       attributes: payload.attributes,
//     })
//   })
//   return findRemoteIdFromNewRecord(result)
// }
